import { type Field, Text } from '@pbt/pbt-ui-components'

import ChargeDetailsFieldWrapper from './ChargeDetailsFieldWrapper'

export interface ChargeFieldRemainingQuantityProps {
  remainingQuantityField: Field
}

const ChargeFieldRemainingQuantity = ({
  remainingQuantityField,
}: ChargeFieldRemainingQuantityProps) => (
  <ChargeDetailsFieldWrapper disabled label={remainingQuantityField.label}>
    <Text disabled>{remainingQuantityField.value}</Text>
  </ChargeDetailsFieldWrapper>
)

export default ChargeFieldRemainingQuantity
